







































































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {
  EntityServiceTransaction,
  ServiceRead,
  ServiceTransactionInitState,
  ServiceTransactionStatus
} from '@/store/service-transaction/service-transaction.types';
import {Action, State} from 'vuex-class';
import BoxTextComponent from '@/components/profile/BoxText.vue';
import {Helper} from '../../../util/helper';
import {LoginInfo} from '@/store/auth/auth.types';
import {AuthEnum} from '@/store/auth/auth.enum';
import {AxiosResponse} from 'axios';
import {Toast} from '@/store/toast/toast.types';
import BgTheme1 from '@/components/bg-theme-1.vue';
import {TimeUsed} from '@/services/time.service';
import {MemberServiceType} from '@/store/member/member.enum';


@Component({
  components: {
    BgTheme1,
    BoxTextComponent
  }
})
export default class ActivityConfirmComponent extends Vue {

  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_cancelActivity', {namespace: 'serviceTransaction'}) cancelActivity!: (body: { id: string }) => Promise<AxiosResponse>;
  @Action('_activityById', {namespace: 'serviceTransaction'}) activityById!: (payload: string) => Promise<void>;
  @Action('_updateRead', {namespace: 'serviceTransaction'}) updateRead!: (payload: string) => Promise<void>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_checkJobIsRunning', {namespace: 'serviceTransaction'}) checkJobIsRunning!: () => Promise<AxiosResponse>;

  public loginInfo: LoginInfo = JSON.parse(localStorage.getItem(AuthEnum.Auth) as string) as LoginInfo;
  public lib: Helper = new Helper();
  public serviceTransaction = {
    subService: {}
  } as EntityServiceTransaction;
  public docReady = false;
  public jobRunning = false;
  public titleService = '';
  public dataService = '';
  public phoneService = '';


  async mounted() {
    try {
      await this.Loading(true);
      let {id} = this.$route.params;
      if (!id) {
        await this.$router.push('/history-activity');
        return;
      }
      // check Job Running
      this.checkJobIsRunning().then((res: AxiosResponse) => {
        if (res.status === 200) {
          if (res.data.appCode === 20004) {
            this.jobRunning = true;
          }
        }
      });
      await this.activityById(id);
      this.serviceTransaction = await this.serviceTransactionInitState.service;
      if (this.serviceTransaction.read === ServiceRead.Unread) {
        await this.updateRead(id);
      }
      this.docReady = true;
      this.dataTraServiceType(this.serviceTransaction);
      await this.Loading(false);
    } catch (e) {
      await this.Loading(false);
      await this.$router.push('/history-activity');
      return;
    }
  }

  timeService(service: EntityServiceTransaction) {
    return `${this.lib.formatTime(service.serviceDate)} น.`
  }

  traServiceType(service: EntityServiceTransaction) {
    if(service.serviceType === MemberServiceType.ServiceReceiver) {
      if (this.loginInfo.id === service.memberId) {
        return 'ให้บริการ ';
      } else {
        return 'รับบริการ';
      }
    }else {
      if (this.loginInfo.id === service.memberId) {
        return 'รับบริการ';
      } else {
        return 'ให้บริการ';
      }
    }
  }

  dataTraServiceType(service: EntityServiceTransaction) {

    if(service.serviceType === MemberServiceType.ServiceReceiver) {
      if (this.loginInfo.id === service.memberId) {
        this.dataService = `${service.invite.firstName} ${service.invite.lastName}`;
        this.titleService = 'ผู้รับบริการ';
        this.phoneService = service.invite.mobilePhone;
      } else {
        this.titleService = 'ผู้ให้บริการ';
        this.dataService = `${service.member.firstName} ${service.member.lastName}`;
        this.phoneService = service.phone;
      }
    }else {
      if (this.loginInfo.id === service.memberId) {
        this.dataService = `${service.invite.firstName} ${service.invite.lastName}`;
        this.titleService = 'ผู้ให้บริการ';
        this.phoneService = service.invite.mobilePhone;
      } else {
        this.titleService = 'ผู้รับบริการ';
        this.dataService = `${service.member.firstName} ${service.member.lastName}`;
        this.phoneService = service.phone;
      }
    }
  }


  async cancelActivityClick() {
    try {
      let {id} = this.$route.params;
      let res = await this.cancelActivity({id});
      if (res.status === 200) {
        this.Toast({
          type: 'success',
          heading: 'สำเร็จ',
          message: 'ยกเลิกกิจกรรมสำเร็จ'
        });
        this.$router.push('/history-activity').then();
      }
      this.popupStatus(false);
    } catch (e) {
      this.popupStatus(false);
    }
  }

  tarStatus(text: string) {
    switch (text) {
      case ServiceTransactionStatus.Waiting : {
        return 'รอตอบรับ';
      }
      case ServiceTransactionStatus.Confirm : {
        return 'รอดำเนินการ';
      }
      case ServiceTransactionStatus.CodeGenerated : {
        return 'รอดำเนินการ';
      }
      case ServiceTransactionStatus.Done : {
        return 'เสร็จแล้ว';
      }
      case ServiceTransactionStatus.Running : {
        return 'กำลังดำเนินการ';
      }
      case ServiceTransactionStatus.FinalCodeGenerated : {
        return 'กำลังดำเนินการ';
      }
      case ServiceTransactionStatus.Reject : {
        return 'ยกเลิก';
      }
      case ServiceTransactionStatus.Deleted : {
        return 'ยกเลิกอัตโนมัติ';
      }
      default : {
        return '';
      }
    }
  }

  popupStatus(status: boolean) {
    status
      ? this.$bvModal.show('my-modal')
      : this.$bvModal.hide('my-modal');
  }

  startActivityClick() {
      if(this.serviceTransaction.serviceType === 'Service Receiver') {
          if (this.loginInfo.id === this.serviceTransaction.inviteId) {
            if (this.serviceTransaction.serviceTransactionStatus === ServiceTransactionStatus.Confirm) {
              this.$router.push({
                path: '/payment-select',
                query: {id: this.serviceTransaction.id}
              }).then();
            }else {
              this.$router.push({
                path: '/payment-code-generated',
                query: {id: this.serviceTransaction.id}
              }).then();
            }

          } else {
            this.$router.push({
              path: '/payment-code-verify',
            }).then();
          }
      }else {
          if (this.loginInfo.id === this.serviceTransaction.inviteId) {
            this.$router.push({
              path: '/payment-code-verify',
            }).then();
          } else {
            if (this.serviceTransaction.serviceTransactionStatus === ServiceTransactionStatus.Confirm) {
              this.$router.push({
                path: '/payment-select',
                query: {id: this.serviceTransaction.id}
              }).then();
            } else {
              this.$router.push({
                path: '/payment-code-generated',
                query: {id: this.serviceTransaction.id}
              }).then();
            }
          }
      }
  }

}
